import AddressField from "./fields/address-field";
import CaptchaField from "./fields/captcha-field";
import CheckboxField from "./fields/checkbox-field";
import DateField from "./fields/date-field";
import EmailField from "./fields/email-field";
import MultiSelectField from "./fields/multiselect-field";
import NameField from "./fields/name-field";
import PhoneField from "./fields/phone-field";
import RadioField from "./fields/radio-field";
import SelectField from "./fields/select-field";
import TextField from "./fields/text-field";
import TextAreaField from "./fields/textarea-field";
import TimeField from "./fields/time-field";
import WebsiteField from "./fields/website-field";

export default function GravityFormsField({ field, fieldErrors, ref, state }) {
  switch (field.type) {
    case "ADDRESS":
      return <AddressField field={field} fieldErrors={fieldErrors} />;
    case "CAPTCHA":
      return <CaptchaField field={field} fieldErrors={fieldErrors} ref={ref} />;
    case "CHECKBOX":
      return <CheckboxField field={field} fieldErrors={fieldErrors} />;
    case "DATE":
      return <DateField field={field} fieldErrors={fieldErrors} />;
    case "EMAIL":
      return <EmailField field={field} fieldErrors={fieldErrors} />;
    case "MULTISELECT":
      return <MultiSelectField field={field} fieldErrors={fieldErrors} />;
    case "NAME":
      return <NameField field={field} fieldErrors={fieldErrors} />;
    case "PHONE":
      return <PhoneField field={field} fieldErrors={fieldErrors} />;
    case "RADIO":
      return <RadioField field={field} fieldErrors={fieldErrors} />;
    case "SELECT":
      return <SelectField field={field} fieldErrors={fieldErrors} />;
    case "TEXT":
      return <TextField field={field} fieldErrors={fieldErrors} />;
    case "TEXTAREA":
      return <TextAreaField field={field} fieldErrors={fieldErrors} />;
    case "TIME":
      return <TimeField field={field} fieldErrors={fieldErrors} />;
    case "WEBSITE":
      return <WebsiteField field={field} fieldErrors={fieldErrors} />;
    default:
      return <p>{`Field type not supported: ${field.type}.`}</p>;
  }
}
